// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "7ccc109af76ddd32","396": "5a5240fd68eeba20","460": "e90108c39fb3458e","917": "4ad37c9f2684cd4f","985": "496dc1bc1d133140",}[chunkId] + ".chunk.js"
}